import(/* webpackMode: "eager" */ "/srv/calcom/apps/web/app/error.tsx");
